import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { getLastPath } from '../../utils/getLastPath'

// styles
import colors from '../../styles/colors'

// images
// 홈, 주문, 메뉴, 매장, 정산, 통계, 리뷰, 공지
// 미선택
import HomeImg from '../../assets/image/sidebar/ic-unselect-home.svg'
import OrderImg from '../../assets/image/sidebar/ic-unselect-order.svg'
import MenuImg from '../../assets/image/sidebar/ic-unselect-menu.svg'
import StoreImg from '../../assets/image/sidebar/ic-unselect-store.svg'
import SettlementImg from '../../assets/image/sidebar/ic-unselect-settlement.svg'
import StatImg from '../../assets/image/sidebar/ic-unselect-stat.svg'
import ReviewImg from '../../assets/image/sidebar/ic-unselect-review.svg'
import NoticeImg from '../../assets/image/sidebar/ic-unselect-notice.svg'
// 선택
import HomeSelectImg from '../../assets/image/sidebar/ic-select-home.svg'
import OrderSelectImg from '../../assets/image/sidebar/ic-select-order.svg'
import MenuSelectImg from '../../assets/image/sidebar/ic-select-menu.svg'
import StoreSelectImg from '../../assets/image/sidebar/ic-select-store.svg'
import SettlementSelectImg from '../../assets/image/sidebar/ic-select-settlement.svg'
import StatSelectImg from '../../assets/image/sidebar/ic-select-stat.svg'
import ReviewSelectImg from '../../assets/image/sidebar/ic-select-review.svg'
import NoticeSelectImg from '../../assets/image/sidebar/ic-select-notice.svg'
// 화살표
import ArrowDownImg from '../../assets/image/sidebar/ic-arrow-down.svg'
import ArrowDownHoverImg from '../../assets/image/sidebar/ic-arrow-down-w.svg'
import ArrowUpImg from '../../assets/image/sidebar/ic-arrow-up.svg'
import ArrowUpHoverImg from '../../assets/image/sidebar/ic-arrow-up-g.svg'

let MENU_ITEM = [
  {
    name: '홈',
    id: 1,
    path: '/',
    subMenu: null,
    img: HomeImg,
    activeImg: HomeSelectImg,
    index: 0,
  },
  {
    name: '주문관리',
    id: 2,
    path: '/orderDetail',
    subMenu: [
      {
        name: '당일 주문현황',
        id: 3,
        path: '/todayOrderList',
      },
      { name: '기간별 주문현황', id: 4, path: '/selectOrderList' },
    ],
    activeIndex: 1,
    img: OrderImg,
    activeImg: OrderSelectImg,
    index: 1,
  },
  {
    name: '메뉴•옵션관리',
    id: 5,
    path: '/itemList',
    subMenu: null,
    img: MenuImg,
    activeImg: MenuSelectImg,
    index: 2,
  },
  {
    name: '매장관리',
    id: 6,
    path: '/storeList',
    subMenu: null,
    img: StoreImg,
    activeImg: StoreSelectImg,
    index: 3,
  },
  {
    name: '정산내역',
    id: 7,
    path: '/settlements',
    img: SettlementImg,
    activeImg: SettlementSelectImg,
    index: 4,
  },
  {
    name: '해피오더\n부가세 신고자료',
    id: 11,
    path: '/vatReport',
    subMenu: null,
    img: SettlementImg,
    activeImg: SettlementSelectImg,
    index: 8,
  },
  {
    name: '통계',
    id: 8,
    path: '/totalOrder',
    subMenu: null,
    img: StatImg,
    activeImg: StatSelectImg,
    index: 5,
  },
  {
    name: '리뷰관리',
    id: 9,
    path: '/reviewList',
    subMenu: null,
    img: ReviewImg,
    activeImg: ReviewSelectImg,
    index: 6,
  },
  {
    name: '공지사항',
    id: 10,
    path: '/happyOrderNoticeList',
    subMenu: null,
    img: NoticeImg,
    activeImg: NoticeSelectImg,
    index: 7,
  },
  // {
  //   name: '공지사항',
  //   id: 10,
  //   path: '/noticeList',
  //   subMenu: [
  //     {
  //       name: '해피오더 공지',
  //       id: 11,
  //       path: '/happyOrderNoticeList',
  //     },
  //     { name: '매장 공지', id: 12, path: '/storeNoticeList' },
  //   ],
  //   activeIndex: 2,
  //   img: NoticeImg,
  //   activeImg: NoticeSelectImg,
  //   index: 7,
  // },
]
const HOME_PATH = ['', '/']

function MainMenu({ hideSidebar, isSettlement, isNewNotice }) {
  const navigate = useNavigate()
  const location = useLocation()
  // const [noticeAlert, setNoticeAlert] = useState(false)
  const [activeIndex, setActiveIndex] = useState([])
  const [hoverIndex, setHoverIndex] = useState(null)

  // useEffect(() => {
  //   setNoticeAlert(localStorage.getItem('isNewNotice') === 'true')
  // }, [])

  const onClickAccordion = (index) => {
    if (activeIndex.includes(index)) {
      let filtering = activeIndex.filter((ele, idx) => ele !== index)

      setActiveIndex(filtering)
    } else {
      setActiveIndex([...activeIndex, index])
    }
  }

  const handleSingleMenu = (e, path) => {
    e.preventDefault()

    hideSidebar()
    navigate(path)
  }

  const checkCurrentPage = (idx) => {
    return (
      (idx === 1 &&
        location.pathname.includes(constants.CURRENT_URL.ORDER_LIST)) ||
      (idx === (isSettlement ? 8 : 5) &&
        getLastPath(window.location.pathname).includes(
          constants.CURRENT_URL.NOTICE_LIST,
        ))
    )
  }

  // console.log('$$ menu', isSettlement)

  return (
    <Container>
      {MENU_ITEM.filter(
        (item, idx) =>
          isSettlement ? idx !== 10 : idx !== 1 && idx !== 4 && idx !== 6, // 주문관리, 정산내역, 통계 숨김 (부가세는 항상 노출)
      ).map((menu, idx) =>
        menu.subMenu ? (
          <AccordionWrapper
            key={`menu1-idx${idx}`}
            isOpen={activeIndex.includes(menu.activeIndex)}
            isCurrent={checkCurrentPage(idx)}
            onMouseOut={() => {
              if (activeIndex.includes(menu.activeIndex)) {
                setHoverIndex(null)
              }
            }}
            onMouseOver={() => {
              if (activeIndex.includes(menu.activeIndex)) {
                setHoverIndex(menu.index)
              }
            }}
          >
            <IncludeMenu
              isOpen={activeIndex.includes(menu.activeIndex)}
              onClick={() => onClickAccordion(menu.activeIndex)}
              isCurrent={checkCurrentPage(idx)}
              onMouseOut={() => setHoverIndex(null)}
              onMouseOver={() => setHoverIndex(menu.index)}
            >
              <IconTextWrapper>
                <IconSingle
                  src={
                    hoverIndex === menu.index ||
                    (idx === 1 &&
                      location.pathname.includes(
                        constants.CURRENT_URL.ORDER_LIST,
                      )) ||
                    (idx === (isSettlement ? 8 : 5) &&
                      getLastPath(window.location.pathname).includes(
                        constants.CURRENT_URL.NOTICE_LIST,
                      ))
                      ? menu.activeImg
                      : menu.img
                  }
                />
                <TextSingle>{menu.name}</TextSingle>
              </IconTextWrapper>

              <ArrowImg
                src={
                  activeIndex.includes(menu.activeIndex)
                    ? checkCurrentPage(idx)
                      ? ArrowUpImg
                      : hoverIndex === menu.activeIndex
                      ? ArrowUpImg
                      : ArrowUpHoverImg
                    : hoverIndex === menu.activeIndex
                    ? ArrowDownHoverImg
                    : ArrowDownImg
                }
              />
            </IncludeMenu>
            {activeIndex.includes(menu.activeIndex) && (
              <AccordionItem>
                {menu.subMenu.map((submenu, index) => (
                  <SubMenuAccordionItem
                    key={index}
                    to={submenu.path}
                    isCurrent={
                      getLastPath(submenu.path) ===
                      getLastPath(window.location.pathname)
                    }
                    isOpen={getLastPath(window.location.pathname).includes(
                      idx === 1
                        ? TYPE.PAGE_URL.ORDER_LIST
                        : TYPE.PAGE_URL.NOTICE_LIST,
                    )}
                    isHover={hoverIndex === menu.index}
                    isLast={index === 1}
                    onClick={(e) => handleSingleMenu(e, submenu.path)}
                  >
                    {`- ${submenu.name}`}
                  </SubMenuAccordionItem>
                ))}
              </AccordionItem>
            )}
          </AccordionWrapper>
        ) : (
          <SingleMenu
            key={`menu2-idx${idx}`}
            isCurrent={
              idx !== 0
                ? (() => {
                    var pathsToCheck = [
                      menu.path,
                      'manageStoreInfo',
                      'storeDeliveryInfo',
                    ]
                    let pathsToChecks = [menu.path, 'optionList']

                    if (idx == (isSettlement ? 2 : 1)) {
                      return pathsToChecks.some((path) =>
                        location.pathname.includes(path),
                      )
                    }

                    if (idx === (isSettlement ? 3 : 2)) {
                      // if (idx === 3) {
                      return pathsToCheck.some((path) =>
                        location.pathname.includes(path),
                      )
                    } else {
                      return location.pathname.includes(menu.path)
                    }
                  })()
                : HOME_PATH.includes(getLastPath(window.location.pathname))
            }
            onMouseOut={() => setHoverIndex(null)}
            onMouseOver={() => setHoverIndex(menu.index)}
            onClick={(e) => handleSingleMenu(e, menu.path)}
          >
            <IconTextWrapper>
              <IconSingle
                src={
                  hoverIndex === menu.index ||
                  (idx !== 0
                    ? (() => {
                        let pathsToCheck = [
                          menu.path,
                          'manageStoreInfo',
                          'storeDeliveryInfo',
                        ]

                        let pathsToChecks = [menu.path, 'optionList']

                        if (idx == (isSettlement ? 2 : 1)) {
                          return pathsToChecks.some((path) =>
                            location.pathname.includes(path),
                          )
                        }

                        if (idx === (isSettlement ? 3 : 2)) {
                          // if (idx === 3) {
                          return pathsToCheck.some((path) =>
                            location.pathname.includes(path),
                          )
                        } else {
                          return location.pathname.includes(menu.path)
                        }
                      })()
                    : HOME_PATH.includes(getLastPath(window.location.pathname)))
                    ? menu.activeImg
                    : menu.img
                }
              />

              <TextSingle>{menu.name}</TextSingle>
              {MENU_ITEM.filter(
                (item, idx) =>
                  isSettlement
                    ? idx !== 10
                    : idx !== 1 && idx !== 4 && idx !== 6,
              ).length -
                1 ===
                idx &&
                isNewNotice && (
                  <AlertSingle
                    isCurrent={
                      (idx === (isSettlement ? 8 : 5) &&
                        window.location.pathname.includes(
                          constants.CURRENT_URL.NOTICE_LIST,
                        )) ||
                      hoverIndex === menu.index
                    }
                  />
                )}
            </IconTextWrapper>
          </SingleMenu>
        ),
      )}
    </Container>
  )
}

export default MainMenu

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;

  @media ${(props) => props.theme.tablet} {
    padding: 0 16px 0 16px;
  }

  @media ${(props) => props.theme.mobile} {
    padding: 0 30px;
    min-width: 200px;
  }
`

const SingleMenu = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  width: 100%;
  font-weight: 500;
  padding: 14px 20px;
  background-color: ${(props) =>
    props.isCurrent ? `${colors.mainG}` : `${colors.W2}`};
  border-radius: ${(props) => (props.isCurrent ? '12px' : '0px')};
  color: ${(props) => (props.isCurrent ? 'white' : 'black')};

  &:hover {
    background-color: ${colors.mainG};
    color: white;
    border-radius: 12px;
    cursor: pointer;
  }

  @media ${(props) => props.theme.tablet} {
    padding: 14px 20px 14px 30px;
    background-color: ${(props) =>
      props.isCurrent ? `${colors.mainG}` : `${colors.W1}`};
  }

  @media ${(props) => props.theme.mobile} {
    padding: 14px 20px;
  }
`

const IconTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

const IconSingle = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 16px;
`

const ArrowImg = styled.img`
  width: 12px;
  height: 12px;
`

const AlertSingle = styled.div`
  display: flex;
  position: absolute;
  right: 0px;
  top: 2px;
  font-size: 12px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) => (props.isCurrent ? 'white' : '#ff4d1d')};
`

const TextSingle = styled.div`
  font-size: 17px;
  font-weight: 700;
  /* margin-right: 12px; */
  margin-top: 2px;
  white-space: pre-line;
  line-height: 1.3;
`

const IncludeMenu = styled.div`
  width: 100%;
  min-height: 40px;
  padding: 14px 20px 16px 20px;
  margin-bottom: ${(props) => (props.isOpen ? '0px' : '6px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: ${(props) => (props.isCurrent ? '12px' : '0px')};
  background-color: ${(props) => props.isCurrent && `${colors.mainG}`};
  color: ${(props) => props.isCurrent && 'white'};

  &:hover {
    background-color: ${colors.mainG};
    color: white;
    border-radius: 12px;
    cursor: pointer;
  }

  @media ${(props) => props.theme.tablet} {
    padding: 14px 20px 14px 30px;
  }

  @media ${(props) => props.theme.mobile} {
    padding: 14px 20px;
  }
`

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: black;
  margin-bottom: ${(props) => (props.isOpen ? '6px' : '0px')};

  border-radius: ${(props) =>
    props.isOpen && props.isCurrent ? '12px' : '0px'};
  background-color: ${(props) =>
    props.isOpen && props.isCurrent ? `${colors.mainG}` : `${colors.W2}`};

  ${(props) =>
    props.isOpen &&
    css`
      &:hover ${IncludeMenu} {
        color: white;
        border-radius: 12px;
      }
    `}

  ${(props) =>
    props.isOpen &&
    css`
      &:hover {
        background-color: ${colors.mainG};
        border-radius: 12px;
      }
    `}
    
    &:hover ${AlertSingle} {
    background-color: white;
  }

  @media ${(props) => props.theme.tablet} {
    background-color: ${(props) =>
      props.isOpen && props.isCurrent ? `${colors.mainG}` : `${colors.W1}`};
  }
`

const AccordionItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-left: 48px;
  /* padding-left: 58px; */

  @media ${(props) => props.theme.tablet} {
    padding-left: 48px;
    margin-top: 7px;
  }

  @media ${(props) => props.theme.mobile} {
    padding-left: 48px;
    /* padding-left: 58px; */
  }
`

const SubMenuAccordionItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 15px;
  margin-bottom: ${(props) => (props.isLast ? '18px' : '20px')};

  color: ${(props) =>
    props.isCurrent && props.isOpen
      ? `${colors.W1}`
      : props.isOpen || props.isHover
      ? '#99dba4'
      : `${colors.BK}`};

  &:hover {
    background-color: ${colors.mainG};
    color: ${colors.W1};
    border-radius: 12px;
    cursor: pointer;
  }

  @media ${(props) => props.theme.tablet} {
    margin-bottom: ${(props) => (props.isLast ? '18px' : '25px')};
  }
`
